import { render, staticRenderFns } from "./Allergen.vue?vue&type=template&id=80522142&"
import script from "./Allergen.vue?vue&type=script&lang=js&"
export * from "./Allergen.vue?vue&type=script&lang=js&"
import style0 from "./Allergen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
